(function () {
  var offerHost = "oferta.useblessy.com.br";
  var discountCodePattern = /^[A-Z0-9_-]{2,40}$/;

  function readCookie(name) {
    var parts = String(document.cookie || "").split(";");

    for (var index = 0; index < parts.length; index += 1) {
      var item = parts[index].trim();
      if (item.indexOf(name + "=") !== 0) continue;

      try {
        return decodeURIComponent(item.slice(name.length + 1));
      } catch (error) {
        return "";
      }
    }

    return "";
  }

  function normalizeCode(value) {
    var code = String(value || "").trim().toUpperCase();
    return discountCodePattern.test(code) ? code : "";
  }

  function getDiscountCode() {
    return normalizeCode(readCookie("discount_code"));
  }

  function shouldDecorate(url) {
    if (!url) return false;
    if (url.hostname !== offerHost) return false;
    if (url.protocol !== "https:" && url.protocol !== "http:") return false;
    return !url.searchParams.get("disc_code");
  }

  function decorateLink(link, code) {
    var href = link.getAttribute("href");
    var url;

    if (!href || href.charAt(0) === "#") return;

    try {
      url = new URL(href, window.location.href);
    } catch (error) {
      return;
    }

    if (!shouldDecorate(url)) return;

    url.searchParams.set("disc_code", code);
    link.setAttribute("href", url.toString());
  }

  function decorateOfferLinks(rootNode) {
    var code = getDiscountCode();
    var scope = rootNode || document;
    var links;

    if (!code || !scope.querySelectorAll) return;

    links = Array.prototype.slice.call(scope.querySelectorAll("a[href]"));
    links.forEach(function (link) {
      decorateLink(link, code);
    });
  }

  function scheduleDecorations() {
    decorateOfferLinks(document);

    if (document.addEventListener) {
      document.addEventListener("DOMContentLoaded", function () {
        decorateOfferLinks(document);
      });
    }

    window.setTimeout(function () {
      decorateOfferLinks(document);
    }, 0);
    window.setTimeout(function () {
      decorateOfferLinks(document);
    }, 250);

    if (window.MutationObserver && document.documentElement) {
      try {
        var observer = new MutationObserver(function () {
          decorateOfferLinks(document);
        });
        observer.observe(document.documentElement, {
          attributes: true,
          attributeFilter: ["href"],
          childList: true,
          subtree: true
        });
      } catch (error) {
        // Link decoration is best-effort.
      }
    }
  }

  window.BlessyDiscountBridge = {
    decorateOfferLinks: decorateOfferLinks,
    getDiscountCode: getDiscountCode
  };

  scheduleDecorations();
})();
